<template>
  <v-row>
    <v-col
      :class="block.type"
      :cols="getColumns(block.settings)"
      v-for="(item, index) in fetchData"
      :key="index"
    >
      <block
        :data="item"
        :id="id"
        :css="block.settings.style"
        :blockIndex="blockIndex"
        :sectionId="sectionId"
        :settings="block.settings"
        :uiBlockComponent="block.settings.component"
        :sectionTextColor="block.titleColor"
        :theme="theme"
      >
      </block>

    </v-col>
  </v-row>
</template>
<script>
  import section from '@fremcast/section/mixins/section';
  import video from '@fremcast/section/mixins/videos';
  import presentation from '@fremcast/section/mixins/presentation';
  import card from '@fremcast/section/mixins/card';
  export default {
    data() {
      return {
        reRenderKey: 1
      };
    },
    methods: {
      getStyles() {
        return {}
      }
    },
    mixins: [
      section,
      video,
      presentation,
      card
    ],
    components: {
      Block: () => import("./Block")
    }
  }
</script>
<style scoped>
  @media only screen and (max-width: 600px) {
    .Videos {
      padding: 6px;
    }
  }
  </style>
